import { ProductReviewFilterFields } from '@reverbdotcom/commons/src/gql/graphql';
import React from 'react';
import { ProductReviewFilter } from './ProductReviewFilter';

interface Props {
  loading: boolean;
  reviewCount: number;
  filters: ProductReviewFilterFields.Fragment[];
  searchInput: React.ReactNode;
}

export function ProductReviewsFilterRow(props: Props) {
  const { loading, reviewCount, filters, searchInput } = props;

  if (!filters || reviewCount === 0) {
    return null;
  }

  return (
    <div className="d-flex fx-justify-between fx-align-center fx-wrap gap-2">
      {searchInput}
      <div className="d-flex fx-justify-end fx-wrap gap-2">
        {filters.map((filter) => (
          <ProductReviewFilter
            key={filter.name}
            filter={filter}
            loading={loading}
          />
        ))}
      </div>
    </div>
  );
}
